<script setup lang="ts">
import { computed, ref } from 'vue';

const props = defineProps({
    entry: Object,
    selected: Boolean,
    icons: Function,
    colors: Function
})

defineEmits(['toggle'])

const icon = computed(() => props.icons?.(props.entry?.id))
const color = computed(() => props.colors?.(props.entry?.id))
</script>

<template>
    <div class="entry"
        :class="{ selected }"
        @click="$emit('toggle')"
        @keypress="$event => {if ($event.key === 'Enter') $emit('toggle')}"
        @contextmenu="$event => {
            if (selected){
                $emit('toggle')
                $event.preventDefault()
            }
        }"    
        tabindex="0"
        :title=" entry?.localized"
    >
        <img v-if="icon" :src="icon" crossorigin="anonymous" />
        <div v-if="color" class="color_display" :style="{ 'background-color': color }"></div>
        <div class="text"><div class="text_part" v-for="part in entry?.localized.split(/(?=\/)/g)">{{ part }}</div></div>
    </div>
</template>

<style scoped>
.entry {
    background-color: #ffffff;
    color: #334155;
    transition: 0.3s;
    cursor: pointer;
    padding: 0.45rem 0.6rem;
    width: 100%;
    box-sizing: border-box;
    user-select: none;
    border-bottom: 1px solid #eef2f7;

    display: flex;
    align-items: center;
    gap: 0.4rem;
}

.entry:hover {
    background-color: #f1f5f9;
}

.entry.selected {
    background-color: #e1f0e5;
    color: #285238;
}

.entry.selected:hover {
    background-color: #d3e9d9;
}

img {
    width: 2rem;
    height: 2rem;
    object-fit: contain;
}

.color_display {
    min-width: 1rem;
    width: 1rem;
    height: 1rem;
    border-radius: 1rem;
    border: 1px solid rgba(15, 23, 42, 0.16);
}

.text {
    height: fit-content;
    overflow: hidden;
    flex-grow: 1;
    width: 0;
    display: flex;
    flex-direction: row;
    gap: 0rem;
}

.text_part {
    white-space: nowrap;
    flex-shrink: 10000;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 2rem;
}

.text :last-child.text_part {
    flex-shrink: 1;
}
</style>
